import { Component, Param, RuntimeComponent } from '@paperbits/common/ko/decorators';
import * as ko from 'knockout';

import type { MapLocationModel } from '../../mapModel';
import template from './map-runtime.html';

@RuntimeComponent({
    selector: 'map-runtime'
})
@Component({
    selector: 'map-runtime',
    template: template
})
export class MapRuntime {
    constructor() {
        this.layout = ko.observable();
        this.locations = ko.observable();
        this.zoom = ko.observable();
        this.mapType = ko.observable();
        this.apiKey = ko.observable();
        this.markerIcon = ko.observable();
        this.showReplyOffices = ko.observable();
        this.usePopupOverlay = ko.observable();
        this.corporate = ko.observable();
    }

    @Param()
    public layout: ko.Observable<string>;

    @Param()
    public locations: ko.Observable<MapLocationModel[]>;

    @Param()
    public zoom: ko.Observable<number>;

    @Param()
    public mapType: ko.Observable<string>;

    @Param()
    public apiKey: ko.Observable<string>;

    @Param()
    public markerIcon: ko.Observable<string>;

    @Param()
    public showReplyOffices: ko.Observable<boolean>;

    @Param()
    public usePopupOverlay: ko.Observable<boolean>;

    @Param()
    public corporate: ko.Observable<boolean>;
}
